import { useContext, useEffect } from 'react';
import { DispatchContext, StateContext } from '../../state/contexts';
import Job from '../../jobs/types/job';
import FiltersState, { FunctionOf, SelectedOf, ValueOf } from '../state/filters-state';

const useFilterSetup = <Key extends keyof FiltersState>(
  key: Key,
  filter: FunctionOf<Key>,
  // eslint-disable-next-line no-unused-vars
  getAvailable?: (jobs: Job[], allowed: string[]) => ValueOf<Key>[],
  // eslint-disable-next-line no-unused-vars
  getSelected?: (selected: string[]) => SelectedOf<Key>,
) => {
  const state = useContext(StateContext);
  const dispatch = useContext(DispatchContext);

  const { config, data } = state;
  const filterConfig = config.config.filters[key];
  const { allowed, enabled } = filterConfig;
  const selected = typeof getSelected !== 'undefined' ? getSelected(filterConfig.selected) : filterConfig.selected;

  useEffect(() => {
    if (data.type === 'processed' && config.type === 'themed') {
      const available = getAvailable && getAvailable(data.jobs, allowed);
      const filterFunction = enabled ? filter : undefined;
      dispatch({
        type: 'initialize-filter',
        filters: {
          [key]: { filterFunction, selected, available },
        },
      });
    }
  }, [data.type]);
};

export default useFilterSetup;
